<template>
    <div class="row">
        <div class="col-md-10 col-md-offset-1">
            <vue-alert></vue-alert>
            <div class="panel panel-default">
                <div class="panel-heading">Recent Flag Statuses</div>

                <div class="panel-body">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>End Date</th>
                                <th>For</th>
                                <th>Flag Staff</th>
                                <th>Messaging / Reason</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <flag-status-list-item v-for="status in statuses" v-bind:status="status" v-bind:key="status.id"></flag-status-list-item>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../app.js';
    export default {
        data() {
            return {
                statuses: []
            };
        },
        mounted() {
            EventBus.$on('status-added', () => {
                this.loadStatuses();
            });
            this.$alert.setDefault({
                transition: 'smooth'
            });
            this.loadStatuses();
        },
        methods: {
            loadStatuses: function() {
                axios.get("./api/status").then(response => this.statuses = response.data.data);
            }
        }
    }
</script>
